import Axios from 'axios';
import qs from 'qs';
import LS_SERVICE from './localStorage';
import { headerService$ } from './rxjs-sharing';

const API_SERVICE = {
    status(response) {
        const LOGOUT = (res) => {
            if (res.status === 401 || (res.status === 400 && LS_SERVICE.has('loginMobile') === false)) {
                LS_SERVICE.clear();
                headerService$.showHeader({ showHeader: 'false' });
                return;
            }
        }
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response)
        } else {
            LOGOUT(response);
            return Promise.reject(new Error(response.statusText))
        }
    },
    json(response) {
        return response.json()
    },
    error(err) {
        return err;
    },
    get(path) {
        return fetch(`${path}`, {
            headers: {
                'Authorization': LS_SERVICE.get('token')
            }
        })
            .then(this.status)
            .then(this.json)
            .catch(this.error);
    },
    post(path, body) {
        return fetch(`${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Authorization': LS_SERVICE.get('token')
            },
            body: qs.stringify(body),
        })
            .then(this.status)
            .then(this.json)
            .catch(this.error);
    }
}

Axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (res) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // return Promise.reject(error);
    if (res?.response?.status === 401 || (res.status === 400 && LS_SERVICE.has('loginMobile') === false)) {
        // (res?.response?.status === 400 && LS_SERVICE.has('loginMobile') === false)) {
        LS_SERVICE.clear();
        headerService$.showHeader({ showHeader: 'false' });
        return;
    }

    return Promise.reject(res);
});

export default API_SERVICE;
